import React from 'react';
import { Handle, Position } from 'reactflow';
import { BeakerIcon, ShareIcon } from '@heroicons/react/24/outline';
import SocialSettingsModal from './SocialSettingsModal';
import { executeNode as baseExecuteNode } from './socialExecute';

// Base AgentNode component
function SocialNode({ data, icon, nodeName }) {
  // Ensure category is set in the node's data
  const nodeData = {
    ...data,
    category: 'social'
  };

  const hasNonTriggerInputs = nodeData.edges?.some(edge => 
    edge.target === nodeData.id && 
    edge.source !== 'trigger' &&
    edge.data?.sourceCategory !== 'trigger'
  );

  return (
    <div className="bg-dark-200 p-4 rounded-lg min-w-[200px] min-h-[200px]">
      <Handle
        type="target"
        position={Position.Left}
        className="!w-5 !h-5 !bg-dark-300 border-2 border-[#8F9298]"
        style={{ 
          left: '-12px',
          zIndex: 1,
          transform: 'translateY(-50%)'
        }}
      />
      <Handle
        type="source"
        position={Position.Right}
        className="!w-5 !h-5 !bg-dark-300 border-2 border-[#8F9298]"
        style={{ 
          right: '-12px',
          zIndex: 1,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="flex flex-col items-center space-y-5">
        {/* Icon Section */}
        <div className="mb-2">
          <div className="w-16 h-16 rounded-lg bg-purple-500/20 flex items-center justify-center">
            {icon}
          </div>
        </div>

        {/* Content Section */}
        <div className="w-full text-center">
          <div className="font-medium text-lg">{nodeData.label}</div>
          <div className="text-sm text-gray-400 mt-1">
            Output: {nodeData.outputFormat || 'text'}
          </div>
          <div className="text-sm text-gray-400">
            {nodeData.includeProfile === 'yes' ? 'With Profile' : 'No Profile'}
          </div>
          {nodeData.inputDocuments?.length > 0 && (
            <div className="text-sm text-gray-400">
              {nodeData.inputDocuments.length} Document{nodeData.inputDocuments.length !== 1 ? 's' : ''}
            </div>
          )}
          {hasNonTriggerInputs && (
            <div className="text-sm text-gray-400">
              {nodeData.usePreviousOutput === 'yes' ? 'Using prev output' : 'Not using prev output'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// MenuItem component
export function MenuItem({ onSelect }) {
  const icon = <BeakerIcon className="w-6 h-6 text-gray-400" />;
  
  return (
    <button
      onClick={() => onSelect({
        type: 'social',
        name: 'Social Agent',
        label: 'Social Agent',
        category: 'ocial',
        agentType: 'dave', // Default agent type
        outputFormat: 'html',
        includeProfile: 'no',
        systemPrompt: '',
        userPrompt: '',
        inputDocuments: [],
        jsonExample: '',
        outputDestination: 'next',
        documentName: '',
        documentType: 'html',
        usePreviousOutput: 'yes',
        folder_id: null
      })}
      className="flex items-center gap-3 p-4 hover:bg-dark-300 w-full transition-colors rounded-lg"
    >
      <div className="w-10 h-10 rounded-lg bg-gray-500/20 flex items-center justify-center">
        {icon}
      </div>
      <div className="flex-1 text-left">
        <h3 className="font-medium">Social Media</h3>
        <p className="text-sm text-gray-400">Creates social media posts across a range of platforms</p>
      </div>
    </button>
  );
}

// Node component
export function Node({ data }) {

  return (
    <SocialNode 
      data={data} 
      icon={<ShareIcon className="w-6 h-6 text-purple-400" />} 
      nodeName={data.label} 
    />
  );
}

// Export SettingsModal
export const SettingsModal = SocialSettingsModal;

// Export ConnectionRules
// export const ConnectionRules = agentConnectionRules;

// Export executeNode function
export const executeNode = (params) => {
  return baseExecuteNode({
    ...params,
  });
};

// Default export for the base AgentNode component
export default SocialNode; 